import React from 'react';

import { Divider, Typography } from '@lyearn/ui';

import { FilterHeaderProps } from './types';

function FilterHeaderMobile(props: FilterHeaderProps) {
  const { label } = props;

  return (
    <>
      <Typography
        as="p"
        className="p-20 xs:px-24 xs:pt-32"
        color="text-text-primary"
        variant="heading-s">
        {label}
      </Typography>
      <Divider color="border-interactive-border" />
    </>
  );
}

export default FilterHeaderMobile;
